app.controller("StudentDocsViewController", [
    "$scope", "DocumentsService", "$uibModalInstance", "usSpinnerService", "toastr", "AuthService", "$http", "params",
    function ($scope, DocumentsService, $uibModalInstance, usSpinnerService, toastr, AuthService, $http, params) {
        $scope.attachments = [];
        $scope.docTypes = [];
        $scope.profiles = [];
        $scope.profilesForDocs = [];
        $scope.docs = [];
        $scope.doc = {
            type: null,
            text: null,
            phone: null,
            email: null,
            invoiceRequired: false,
            studentProfileId: null,
            copiesNumber: 1
        };
        $scope.mode = params.mode;
        if(params.doc) $scope.doc = params.doc;
        DocumentsService.studentDocTypes().then(data => {
            $scope.docTypes = data;
            if (params.mode === 'show') {
                $scope.setTypeFromDocument();
            }
        }, () => {
            toastr.error('', 'დოკუმენტის ტიპების ჩატვირთვისას დაფიქსირდა შეცდომა');
        });

        $scope.tinymceOptions = {
            menubar: '',
            toolbar: 'undo redo | underline bold italic | alignleft aligncenter alignright',
            height: "400",
            readonly: params.mode === 'show'
        };

        $scope.setTypeFromDocument = function () {
            for (let i = 0; i < $scope.docTypes.length; i++) {
                if ($scope.docTypes[i]._id === params.doc.type._id) {
                    $scope.doc.type = $scope.docTypes[i];
                    return;
                }
            }
        };

        $scope.print = function () {
            let url = 'documents/export/' + $scope.doc._id + '?withBlank=true';
            window.open(url);
        };

        $scope.download = function (url) {
            window.open(url);
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
